import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Search, FileCheck, BarChart3 } from 'lucide-react';

const steps = [
  {
    num: '01',
    icon: Search,
    title: 'Diagnóstico Gratuito',
    desc: 'Analisamos a situação atual da sua empresa e identificamos oportunidades de economia.',
  },
  {
    num: '02',
    icon: FileCheck,
    title: 'Plano de Ação',
    desc: 'Desenhamos a melhor estratégia tributária e financeira personalizada para o seu negócio.',
  },
  {
    num: '03',
    icon: BarChart3,
    title: 'Crescimento Contínuo',
    desc: 'Acompanhamento mensal com relatórios claros e objetivos. Sua contabilidade sempre em dia.',
  },
];

export default function HowItWorks() {
  const sectionRef = useScrollAnimation();

  return (
    <section
      id="como-funciona"
      data-testid="how-it-works-section"
      ref={sectionRef}
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="scroll-fade text-center mb-16 md:mb-20">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#10B981] mb-4">
            Passo a Passo
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0A2540] tracking-tight leading-tight"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-1px' }}
          >
            Como Funciona
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 stagger-children">
          {steps.map((step, idx) => (
            <div
              key={step.num}
              data-testid={`step-card-${step.num}`}
              className={`scroll-fade relative text-center ${idx < steps.length - 1 ? 'timeline-connector' : ''}`}
            >
              {/* Step Number */}
              <div className="step-number inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#10B981] text-white text-xl font-bold mb-6">
                {step.num}
              </div>

              {/* Icon */}
              <div className="w-12 h-12 mx-auto flex items-center justify-center text-[#0A2540]/40 mb-4">
                <step.icon size={28} strokeWidth={1.5} />
              </div>

              <h3
                className="text-xl font-bold text-[#0A2540] mb-3"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed max-w-xs mx-auto">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
